// extracted by mini-css-extract-plugin
module.exports = {"delta2_p2":"Group2_delta2_p2__Z8fJ5"};